jQuery( document ).ready( function( $ ) {

    $( '.location-sidebar a' ).on( 'click', function( e ) {
        e.preventDefault();
        $( '.location-sidebar a' ).removeClass( 'active' );
        $( this ).addClass( 'active' );
        const location = $( this ).attr( 'data-location' );
        let data = {  
            action: 'get_rlg_listings', 
            location: location,
            nonce: ThemeJS.Variables.Ajax.nonce
        };
        if( ThemeJS.Variables.ListingsFurnished ) {
            data.furnished = ThemeJS.Variables.ListingsFurnished;
        }
        $.post( ThemeJS.Variables.Ajax.url, data, function( response ) {
            let data    = JSON.parse( response );
            let content = data.content;
            $( '.listings-loop' ).html( content );
        });
    });

    // $( '.listings-loop' ).each( function() {

});